import { useAtomValue } from 'jotai';
import { companyStateJ } from '../../../services/state/CompanyStateJ';
import { formatDate } from '../../../util/formatters/DateFormatters';

export function useTransactionTitle(transaction: { companyId: number; transactionDate: string }) {
  const company = useAtomValue(companyStateJ(transaction.companyId));
  const transactionDate = transaction.transactionDate ? formatDate(transaction.transactionDate) : '';
  return `${company?.name ?? ''} transaction${transactionDate ? ', dated ' : ''}${transactionDate}`;
}
